import Recorder from "./Recorder";

export default Recorder;
